module.exports = __webpack_public_path__ + "static/media/4.708fd313.jpg";